import * as React from 'react';

import ImagePreviewModal from 'af-components/ImagePreviewModal';

import styles from './styles.module.scss';

type Props = {
	value: Nullable<string>;
};

const FieldReportBlockImageField: React.FC<Props> = ({ value }) => {
	const [showImageModal, setShowImageModal] = React.useState(false);

	const closeModal = React.useCallback(() => setShowImageModal(false), []);
	const onImageClick = React.useCallback(() => setShowImageModal(true), []);

	return (
		<>
			{value ? <img className={styles['side-panel__field__previewable-image']} onClick={onImageClick} src={value} /> : 'None'}
			{value && (
				<ImagePreviewModal
					closeModal={closeModal}
					imageSrc={value}
					showModal={showImageModal}
				/>
			)}
		</>
	);
};

export default React.memo(FieldReportBlockImageField);
